module.exports = __webpack_public_path__ + "img/f2.9c383311.jpg";